<template>
  <v-expansion-panels class="px-3 py-3" v-model="panel">
    <v-expansion-panel class="ma-0">
      <v-expansion-panel-header class="pa-2" style="background-color: #E0E0E0;">
        <v-toolbar-title class="subtitle-1 font-weight-bold">
          <v-list-item class="mx-0 pa-0">
            <v-list-item-avatar class="ma-1">
              <v-icon>mdi-text-box-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content class="my-0 py-1">
              <v-list-item-title>
                FORMULÁRIO DE PESQUISA DE JURISPRUDÊNCIA SELECIONADA
              </v-list-item-title>
              <v-list-item-subtitle class="caption">
                {{ textForm }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-toolbar-title>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card flat class="mx-auto pb-0 mb-0">
          <v-card-text class="pa-0 pt-4">
            <v-row no-gutters>
              <v-col>
                <v-text-field
                  v-model="form.termo"
                  outlined
                  label="Pesquisa em Todos os campos"
                  append-icon="mdi-magnify"
                  dense
                  @keyup="verificarEnter"
                ></v-text-field>
              </v-col>
            </v-row>

            <h3 class="primary--text mb-4">Informações referentes a Decisão</h3>
            <v-row no-gutters>
              <v-col class="mr-2">
                <v-text-field
                  v-model="form.numero"
                  outlined
                  label="Número"
                  dense
                  v-mask="'########'"
                  @keyup="verificarEnter"
                ></v-text-field>
              </v-col>
              <v-col :class="isMobile ? '' : 'mr-2'">
                <v-text-field
                  v-model="form.ano"
                  outlined
                  label="Ano"
                  dense
                  v-mask="'####'"
                  @keyup="verificarEnter"
                ></v-text-field>
              </v-col>
              <v-col :cols="isMobile ? 12 : 4">
                <v-autocomplete
                  v-model="form.relator"
                  outlined
                  label="Relator"
                  :items="relatores"
                  item-text="key"
                  item-value="key"
                  dense
                  clearable
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col :cols="isMobile ? 12 : ''" class="mr-2">
                <v-autocomplete
                  v-model="form.classificacao_tematica"
                  outlined
                  label="Classificação temática"
                  :items="classificacoesTematicas"
                  item-text="key"
                  item-value="key"
                  dense
                  clearable
                ></v-autocomplete>
              </v-col>
              <v-col :cols="isMobile ? 12 : ''" class="mr-2">
                <v-autocomplete
                  v-model="form.paradigmatica"
                  outlined
                  label="Paradigmáticas"
                  :items="paragmaticas"
                  item-text="key"
                  item-value="key"
                  dense
                  clearable
                ></v-autocomplete>
              </v-col>
              <v-col :cols="isMobile ? 12 : ''">
                <v-autocomplete
                  v-model="form.assunto"
                  outlined
                  label="Palavras-chave"
                  :items="assuntos"
                  item-text="key"
                  item-value="key"
                  dense
                  clearable
                ></v-autocomplete>
              </v-col>
            </v-row>
            <h3 class="primary--text mb-4">Referência legislativa</h3>
            <v-row no-gutters>
              <v-col :cols="isMobile ? 12 : ''">
                <v-autocomplete
                  v-model="form.normativo"
                  outlined
                  label="Normativo"
                  :items="normativos"
                  item-text="key"
                  item-value="key"
                  dense
                  clearable
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col :cols="isMobile ? 12 : ''" class="mr-2">
                <v-text-field
                  v-model="form.artigo"
                  outlined
                  label="Artigo"
                  dense
                  @keyup="verificarEnter"
                ></v-text-field>
              </v-col>
              <v-col :cols="isMobile ? 12 : ''" class="mr-2">
                <v-text-field
                  v-model="form.paragrafo"
                  outlined
                  label="Parágrafo"
                  dense
                  @keyup="verificarEnter"
                ></v-text-field>
              </v-col>
              <v-col :cols="isMobile ? 12 : ''" class="mr-2">
                <v-text-field
                  v-model="form.inciso"
                  outlined
                  label="Inciso"
                  dense
                  @keyup="verificarEnter"
                ></v-text-field>
              </v-col>
              <v-col :cols="isMobile ? 12 : ''" class="mr-2">
                <v-text-field
                  v-model="form.alinea"
                  outlined
                  label="Alínea"
                  dense
                  @keyup="verificarEnter"
                ></v-text-field>
              </v-col>
              <v-col :cols="isMobile ? '' : 'auto'">
                <v-btn block color="primary" @click="buscar">
                  <v-icon class="mr-2">mdi-magnify</v-icon>
                  buscar
                </v-btn>
              </v-col>
              <v-col :cols="isMobile ? '' : 'auto'">
                <v-btn block color="orange" dark @click="limpar" class="mx-1">
                  limpar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
import Vue from "vue";
export default {
  props: {
    filtrosFormulario: {},
    panelForm: { type: Number },
    isMobile: { type: Boolean, default: false }
  },
  data() {
    return {
      form: {
        // relevancia: ""
      },
      textForm: "Clique para ocultar o formulário de pesquisa",
      panel: 0,
      relatores: [],
      tiposDecisao: [],
      classificacoesTematicas: [],
      paragmaticas: [],
      assuntos: [],
      emissores: [],
      normativos: []
    };
  },
  mounted() {
    this.form = this.filtrosFormulario;
    this.getAggregations();
  },
  watch: {
    filtrosFormulario: {
      handler() {
        this.form = this.filtrosFormulario;
        // this.panel = 1;
      }
    },
    panel: {
      handler() {
        if (this.panel == 0) {
          this.textForm = "Clique para ocultar o formulário de pesquisa";
        } else {
          this.textForm =
            "Clique para expandir o formulário de pesquisa e realizar uma nova pesquisa";
        }
        this.$emit("expandirPanel", this.panel);
      }
    }
  },
  methods: {
    verificarEnter(event) {
      if (event.keyCode === 13) {
        this.buscar();
      }
    },
    getAggregations() {
      Vue.axios({
        method: "get",
        url: process.env.VUE_APP_URL + "/jurisprudencia/tipos",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(responseTipos => {
        this.tiposDecisao =
          responseTipos.data.data.aggregations.SessaoTipo.buckets;
        this.classificacoesTematicas =
          responseTipos.data.data.aggregations.ClassificacaoTematica.buckets;
        this.paragmaticas =
          responseTipos.data.data.aggregations.Paradigmatica.buckets;
        this.assuntos =
          responseTipos.data.data.aggregations.AssuntoDescritor.buckets;
        this.emissores =
          responseTipos.data.data.aggregations.LegislacaoEmissor.buckets;
        this.normativos =
          responseTipos.data.data.aggregations.LegislacaoNormativo.buckets;
        this.relatores = responseTipos.data.data.aggregations.Relator.buckets;
      });
    },
    buscar() {
      // console.log(this.form);
      this.panel = 1;
      this.form.hash = "";
      this.form.historico = false;
      this.form.selected = 0;
      this.form.isMobile = this.isMobile;
      this.$emit("search", this.form);
    },
    limpar() {
      this.form = {};
    }
  }
};
</script>
